function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export default {
  methods: {
    getTagsFilterOptions: function getTagsFilterOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var optionMap = this.optionMap,
          innerValue = this.innerValue,
          searchInputValue = this.searchInputValue;

      var nOptionMap = _objectSpread({}, optionMap);

      var tagsOptions = _toConsumableArray(options);

      var extraOptions = innerValue.filter(function (v) {
        return !(v in nOptionMap) && (!searchInputValue || String(v).indexOf(searchInputValue) > -1);
      }).map(function (v) {
        // 只需要标示有这个值即可
        nOptionMap[v] = 1;
        return {
          value: v,
          label: v,
          content: v
        };
      });
      tagsOptions.push.apply(tagsOptions, _toConsumableArray(extraOptions));

      if (searchInputValue && !(searchInputValue in nOptionMap)) {
        tagsOptions.unshift({
          value: searchInputValue,
          label: searchInputValue,
          content: searchInputValue
        });
      }

      return tagsOptions;
    }
  }
};